"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputPassword = void 0;
const react_1 = require("react");
const useInputPassword = () => {
    const [inputRail, setInputRail] = (0, react_1.useState)(undefined);
    const [isVisible, setVisible] = (0, react_1.useState)(false);
    const [inputType, setInputType] = (0, react_1.useState)('password');
    const railTextHandler = (value, length) => {
        const railLength = length || 6;
        let text = value === null || value === void 0 ? void 0 : value.slice(0, railLength);
        let updatedMask = '';
        const hasOnlyNumbers = /^\d+$/g.test(value);
        if (!hasOnlyNumbers) {
            text = text === null || text === void 0 ? void 0 : text.replace(/\D+/g, '');
        }
        for (let i = 0; i < railLength; i += 1) {
            updatedMask += i < (text === null || text === void 0 ? void 0 : text.length) ? ' ' : 'o';
        }
        setInputRail(updatedMask);
        return text;
    };
    (0, react_1.useEffect)(() => {
        setInputType(isVisible ? 'text' : 'password');
    }, [isVisible]);
    return { isVisible, setVisible, inputType, inputRail, railTextHandler };
};
exports.useInputPassword = useInputPassword;
//# sourceMappingURL=usePassword.js.map